import { SortDescriptor } from '@progress/kendo-data-query';
import { RecommendationStatus, RecommendationValueState } from '../infrastructure/enums/meta-data-field.enum';

export class Recommendation {
  companyType: string;
  companyKey: string;
  type: RecommendationType;
  entityType: RecommendationEntityType;
  entityKey: string;
  entitySnapshot: any;
  recommendationOutput: any;
  dataInput: any;
  status: RecommendationStatus;
  valueState: RecommendationValueState;

  constructor(init?: Partial<Recommendation>) {
    if (init) {
      // if no values are passed in, fresh instantiation
      Object.assign(this, init);
    }
  }
}

export enum RecommendationEntityType {
  ITEM = "ITEM",
}

export enum RecommendationType {
  PRICE = "PRICE",
}

export interface IFilterItemsByRecommendation {
  skip: number;
  take: number;
  filter: any;
  sort: SortDescriptor[];
}

export interface BaseApplyRecommendationPayload {
  entityType: RecommendationEntityType;
  type: RecommendationType;
  customPrices?: Record<string, number>;
  customMinPrices?: Record<string, number>;
  customMaxPrices?: Record<string, number>;
}

export interface ExplicitApplyRecommendationPayload extends BaseApplyRecommendationPayload {
  isSelectAll?: false;
  entityKeys: string[];
}

export interface ImplicitApplyRecommendationPayload extends BaseApplyRecommendationPayload {
  isSelectAll: true;
  filter: any;
  excludedKeys?: string[];
}

export type ApplyRecommendationPayload = ExplicitApplyRecommendationPayload | ImplicitApplyRecommendationPayload;
